import { useState, useEffect, useRef } from 'react';
import apifunctions from '../components/Tienda/api/functions';

const useApiData = (url, id = null, depth = null, parameters = {}, transform = response => response) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const transformRef = useRef(transform);
  transformRef.current = transform;

  useEffect(() => {
    let canceled = false;

    const successCallback = (response) => {
      if (canceled) return;
      try {
        const transformed = transformRef.current(response);
        setData(transformed);
      } catch (e) {
        setData(null);
      }
      setError(null);
      setLoading(false);
    };

    const failureCallback = (err) => {
      if (canceled) return;
      setError(err);
      setData(null);
      setLoading(false);
    };

    setLoading(true);
    setError(null);
    apifunctions.get(url, id, depth, parameters, successCallback, failureCallback, failureCallback);

    return () => {
      canceled = true;
    };
  }, [url, id, depth, parameters]);

  return { data, loading, error };
};

export default useApiData;
